import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Dialog from '../dialog/Dialog';
import RecordIdentifier from './RecordIdentifier';
import RecordLink from './RecordLink';
import RecordEmbedCode from './RecordEmbedCode';
import './RecordShareInformation.css';
import { ReactComponent as ShareIcon } from '.././utilities/icons/share.svg';

const RecordShareInformationContent = ({ identifier, publishedLink, isPublished, startFrom }) => {
    return (
        <Container>
            <Row className="mb-4">
                <Col>
                    <RecordIdentifier identifier={identifier} />
                </Col>
            </Row>
            <Row className="mb-4">
                <Col>
                    <RecordLink to={publishedLink} label={publishedLink} showNotice={!isPublished} startFrom={startFrom} />
                </Col>
            </Row>
            {isPublished && (
                <Row className="mb-4">
                    <Col>
                        <RecordEmbedCode identifier={identifier} />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

const RecordShareInformation = ({ identifier, publishedLink, isPublished, title, startFrom }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const headerId = useId();

    const hideDialog = () => setShow(false);
    const toggle = () => setShow(!show);

    const showButton = (
        <Button
            onClick={toggle}
            variant="primary" a
            ria-label={t('record_share_button_aria_label')}
            aria-haspopup="dialog"
            className="record-share-button"
            size="sm"
        >
            <ShareIcon aria-hidden="true" />
            <span>{t('record_share_button_text')} </span>
        </Button>
    );

    return (
        <Dialog showComponent={showButton} show={show} hide={hideDialog} aria-labelledby={headerId}>
            <Modal.Header id={headerId} closeButton closeLabel={t('help_dialog_close_label')}>
                {t('record_share_information_header')} "{title}"
            </Modal.Header>
            <Modal.Body>
                <RecordShareInformationContent
                    identifier={identifier}
                    publishedLink={publishedLink}
                    isPublished={isPublished}
                    startFrom={startFrom}
                />
            </Modal.Body>
        </Dialog>
    );
};

RecordShareInformation.propTypes = {
    identifier: PropTypes.string,
    publishedLink: PropTypes.string,
    isPublished: PropTypes.bool,
    startFrom: PropTypes.number,
};

export default RecordShareInformation;
